import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

import styles from './main.module.css';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import logo from '../assets/images/logoChungungoR.png';
import stepOne from '../assets/images/paso1.png';
import stepTwo from '../assets/images/paso2.png';
import stepThree from '../assets/images/paso3.png';
import stepFour from '../assets/images/paso4.png';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';

const Home = (props) => {
    let link = '/elige-un-plan';
    const params = queryString.parse(props.location.search);
    if (params.from){
        link += `?from=${params.from}`;
    }

    return (
        <>
        <header className={`fixed-top ${styles.navbarRegala}`}>
            <nav className={`navbar navbar-expand `} aria-label="Eighth navbar example">
                <div className={`container d-flex flex-column flex-lg-row ${styles.navbarContainer}`}>
                    <a className={`navbar-brand ${styles.navbarBrand}`} href="www.chungungo.com">
                        Hagamos Cosas Juntos
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
                    aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse ${styles.collapse} navbar-collapse`}>
                        <ul className="navbar-nav ml-lg-auto">
                            <li className={`nav-item ${styles.navbarBtn}`}>
                                <a className="nav-link" href={link}>Empieza ya</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <section className={`${styles.sectionOne}`}>
            <div className={`row ${styles.rowFixed}`}>
                <div className={`col-md-6 col-sm-12 ${styles.titleContainer}`}>
                    <div>
                    <h2>Regala Chungungo</h2>
                    <p>Elige uno de los planes de suscripción Chungungo y regálaselo a quien tú quieras.
                        <br />Sólo sigue los pasos, es fácil y seguro.</p>
                    </div>

                </div>
                <div className={`col-md-6 ${styles.logoIMG}`}>
                    <img src={logo} alt="Chungungo" />
                    <div className={`${styles.backgroundIMG}`}>
                    
                    </div>
                </div>

            </div>
        </section>

        <section className={`${styles.sectionTwo}`}>
            <div className={`row ${styles.rowFixed} ${styles.stepsContainer} text-center`}>
                <div className="col-md-3 col-sm-12">
                    <div className={`${styles.stepContainer}`}>
                        <img src={stepOne} alt="Paso 1" />
                        <p>Elige un plan.</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className={`${styles.stepContainer}`}>
                        <img src={stepTwo} alt="Paso 2" />
                        <p>Paga Online.</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className={`${styles.stepContainer}`}>
                        <img src={stepThree} alt="Paso 3" />
                        <p>¿Para quién es?</p>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className={`${styles.stepContainer}`}>
                        <img src={stepFour} alt="Paso 4" />
                        <p>¡Y Listo!</p>
                    </div>
                </div>
            </div>
            <div className={`row ${styles.stepText} ${styles.rowFixed} text-center`}>
                <div className={`col-md-12 text-center`}>
                    <p>Sigue los pasos uno a uno y recuerda que una suscripción a Chungungo te da acceso al 100% de sus contenidos, actualizaciones y sorpresas especiales para suscriptores.</p>
                    <a href={link} className={`${styles.pinkBtn} btn btn-primary text-light`}>¡Empieza ya!</a>
                </div>
            </div>
        </section>


        <footer className={`${styles.footer}`}>
            <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                <ul className="nav justify-content-center">
                    <li className="nav-item">
                    <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/about">Acerca de</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                    </li>
                </ul>
                <ul className="nav justify-content-center mb-5">
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                    </li>
                </ul>
                <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
                </div>
            </div>
            </div>
            <div className={`${styles.unicef}`}>
                <img src={unicefLogo} alt="Patrocinio Unicef" />
            </div>
        </footer>
        
        </>

    )

}

export default withRouter(Home);